import { Component } from '@angular/core';
import { UtilService } from '../../../../core/services/util/util.service';
import { PlatformService } from '../../../../core/services/platform/platform.service';
import { Color, ScaleType } from '@swimlane/ngx-charts';
import { PuchaseAnalysisService } from '../../services/api/puchase-analysis.service';
import { PlatformGroupService } from '../../../../core/services/platform-group/platform-group.service';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-purchase-analysis-sale',
  templateUrl: './purchase-analysis-sale.component.html',
  styleUrl: './purchase-analysis-sale.component.css'
})
export class PurchaseAnalysisSaleComponent {
  channels: any[] = [];
  platformGroup: any[] = [];

  saleDatasets: { name: string, series: { name: string, value: number }[] }[] = [];
  barDatasets: { name: string, value: number }[] = [];

  formattedData: { date: string, channel: string, total_order: number, total_amount: number, subtotal: number, total_discount: number }[] = []

  selectedDate = { type: 'daypass', value: '0' };
  selectedPlatfromGroup: any[] = [];
  readonly ALL_GROUP_MARKER = '__all__';

  chartType: 'bar' | 'line' = 'bar'

  summary = {
    totalOrder: 0,
    subtotal: 0,
    totalDiscount: 0,
    totalAmount: 0,
    avgAmount: 0
  }

  displayData: 'total_order' | 'total_amount' = 'total_order';

  colorScheme: Color = {
    domain: [],
    group: ScaleType.Ordinal,
    selectable: true,
    name: 'platform color'
  }

  loading = false

  readonly faChevronDown = faChevronDown;
  readonly faChevronRight = faChevronRight;

  constructor(
    private utilService: UtilService,
    private platformService: PlatformService,
    private puchaseAnalysisService: PuchaseAnalysisService,
    private platfromGroupService: PlatformGroupService,
  ) { }

  ngOnInit(): void {
    this.platformGroup = this.platfromGroupService.platformGroup;
    const groupIds = this.platformGroup.map(item => item.id);
    this.channels = this.platformService.channelsAll.filter(item => groupIds.includes(item.platform_group_id));
    this.getDataReport();
  }

  async getDataReport() {

    this.loading = true;

    let filters: any = {}

    if (this.selectedPlatfromGroup?.length > 0) {
      filters['platform_group_id'] = this.selectedPlatfromGroup.toString()
    } else {
      filters['platform_group_id'] = this.platformGroup.map((item) => item.id).toString()
    }

    if (this.selectedDate.type === 'daypass') {

      if (this.selectedDate.value === '0') {
        this.chartType = 'bar'
        const date = this.utilService.dayjs().format('YYYY-MM-DD')
        const dateRange = [date, date].toString()
        filters = { ...filters, date: dateRange }
        const result: any = await this.puchaseAnalysisService.getSaleReportByDateRange(filters)
        this.formattedData = result.data.map((item: any) => ({ ...item, date: item.date }));
        this.saleDatasets = this.formatData(this.formattedData)

      } else if (this.selectedDate.value === '1') {
        this.chartType = 'bar'
        const date = this.utilService.dayjs().subtract(parseInt(this.selectedDate.value), 'day').format('YYYY-MM-DD')
        const dateRange = [date, date].toString()
        filters = { ...filters, date: dateRange }
        const result: any = await this.puchaseAnalysisService.getSaleReportByDateRange(filters)
        this.formattedData = result.data.map((item: any) => ({ ...item, date: item.date }));
        this.saleDatasets = this.formatData(this.formattedData)
      } else if (this.selectedDate.value === 'month') {
        const startDate = this.utilService.dayjs().startOf('month').format('YYYY-MM-DD')
        const endDate = this.utilService.dayjs().format('YYYY-MM-DD')
        this.chartType = startDate === endDate ? 'bar' : 'line'
        const dateRange = [startDate, endDate].toString()
        filters = { ...filters, date: dateRange }
        const result: any = await this.puchaseAnalysisService.getSaleReportByDateRange(filters)
        this.formattedData = result.data.map((item: any) => ({ ...item, date: item.date }));
        this.saleDatasets = this.formatData(this.formattedData)
      } else {
        this.chartType = 'line'
        const startDate = this.utilService.dayjs().subtract(parseInt(this.selectedDate.value), 'day').format('YYYY-MM-DD')
        const endDate = this.utilService.dayjs().subtract(1, 'day').format('YYYY-MM-DD')
        const dateRange = [startDate, endDate].toString()
        filters = { ...filters, date: dateRange }
        const result: any = await this.puchaseAnalysisService.getSaleReportByDateRange(filters)
        this.formattedData = result.data.map((item: any) => ({ ...item, date: item.date }));
        this.saleDatasets = this.formatData(this.formattedData)
      }
    }
    if (this.selectedDate.type === 'date-range') {
      const startDate = this.utilService.dayjs(this.selectedDate.value.split(',')[0]).format('YYYY-MM-DD')
      const endDate = this.utilService.dayjs(this.selectedDate.value.split(',')[1]).format('YYYY-MM-DD')

      if (startDate != endDate) {
        this.chartType = 'line'
        const dateRange = [startDate, endDate].toString()
        filters = { ...filters, date: dateRange }
        const result: any = await this.puchaseAnalysisService.getSaleReportByDateRange(filters)
        this.formattedData = result.data.map((item: any) => ({ ...item, date: item.date }));
        this.saleDatasets = this.formatData(this.formattedData)

      } else {
        this.chartType = 'bar'
        const dateRange = [startDate, endDate].toString()
        filters = { ...filters, date: dateRange }
        const result: any = await this.puchaseAnalysisService.getSaleReportByDateRange(filters)
        this.formattedData = result.data.map((item: any) => ({ ...item, date: item.date }));
        this.saleDatasets = this.formatData(this.formattedData)
      }
    }
    this.loading = false;
  }

  formatData(data: { date: string, channel: string, total_order: number, total_amount: number, subtotal: number, total_discount: number }[]) {

    this.summary = {
      totalOrder: 0,
      subtotal: 0,
      totalDiscount: 0,
      totalAmount: 0,
      avgAmount: 0
    }
    for (const item of data) {
      this.summary.totalOrder += item.total_order;
      this.summary.subtotal += item.subtotal;
      this.summary.totalDiscount += item.total_discount;
      this.summary.totalAmount += item.total_amount;
    }
    this.summary.totalOrder = parseFloat((this.summary.totalOrder).toFixed(2))
    this.summary.subtotal = parseFloat((this.summary.subtotal).toFixed(2))
    this.summary.totalDiscount = parseFloat((this.summary.totalDiscount).toFixed(2))
    this.summary.totalAmount = parseFloat((this.summary.totalAmount).toFixed(2))
    this.summary.avgAmount = this.summary.totalOrder > 0
      ? parseFloat((this.summary.totalAmount / this.summary.totalOrder).toFixed(2))
      : 0

    const uniqueDate = [...new Set(data.map(item => item.date))].sort()
    const result = []
    const platfromGroup: string[] = this.selectedPlatfromGroup?.length > 0 ? this.selectedPlatfromGroup : this.platformGroup.map(item => item.id)

    this.colorScheme.domain = []


    const groupChannels = new Map<string, string[]>();
    for (const groupId of platfromGroup) {
      const platfromGroupDetial = this.platformGroup.find(item => item.id === groupId)
      if (!platfromGroupDetial) continue

      const channels = this.channels.filter(item => item.platform_group_id === groupId).map(el => el.shop_ref)
      groupChannels.set(groupId, channels)
      const reportGroup = data.filter(item => channels.includes(item.channel))

      this.colorScheme.domain.push(platfromGroupDetial.color || '#32436a')
      const series = []
      for (const date of uniqueDate) {
        const reportDate = reportGroup.find(item => item.date === date)
        series.push({
          name: date,
          value: reportDate ? (reportDate[this.displayData] || 0) : 0
        })
      }

      result.push({
        name: platfromGroupDetial.name,
        series
      })
    }

    this.barDatasets = platfromGroup.flatMap(groupId => {
      const detail = this.platformGroup.find(g => g.id === groupId);
      const channels = groupChannels.get(groupId);
      if (!detail || !channels) return [];
      const value = data
        .filter(item => channels.includes(item.channel))
        .reduce((sum, r) => sum + (r[this.displayData] || 0), 0);
      return [{ name: detail.name, value }];
    });

    return result
  }

  handleOptionSelected(selectedDate: { type: string, value: string }) {
    this.selectedDate = selectedDate
  }

  get displayedPlatformGroupSelection(): string[] {
    if (this.platformGroup.length > 0 && this.selectedPlatfromGroup.length === this.platformGroup.length) {
      return [this.ALL_GROUP_MARKER, ...this.selectedPlatfromGroup];
    }
    return this.selectedPlatfromGroup;
  }

  onPlatformGroupSelectionChange(values: any[]) {
    const list = Array.isArray(values) ? values : [];
    const wasAllSelected = this.platformGroup.length > 0
      && this.selectedPlatfromGroup.length === this.platformGroup.length;
    const newHasMarker = list.includes(this.ALL_GROUP_MARKER);

    if (newHasMarker !== wasAllSelected) {
      this.selectedPlatfromGroup = newHasMarker
        ? this.platformGroup.map(g => g.id)
        : [];
    } else {
      this.selectedPlatfromGroup = list.filter((v: any) => v !== this.ALL_GROUP_MARKER);
    }
  }

  displayDataOnchange(event: any) {
    this.displayData = event.value
    this.saleDatasets = this.formatData(this.formattedData)
  }

  expandedGroups = new Set<string>();

  get chartGroups(): Array<{ id: string; name: string; color?: string }> {
    const ids = this.selectedPlatfromGroup?.length > 0
      ? this.selectedPlatfromGroup
      : this.platformGroup.map(g => g.id);
    return ids
      .map(id => this.platformGroup.find(g => g.id === id))
      .filter((g): g is { id: string; name: string; color?: string } => !!g);
  }

  toggleGroupExpanded(groupId: string): void {
    if (this.expandedGroups.has(groupId)) {
      this.expandedGroups.delete(groupId);
    } else {
      this.expandedGroups.add(groupId);
    }
  }

  groupTotal(groupId: string): { total_order: number; total_amount: number } {
    const channelRefs = this.channels
      .filter(c => c.platform_group_id === groupId)
      .map(c => c.shop_ref);
    const rows = this.formattedData.filter(r => channelRefs.includes(r.channel));
    return {
      total_order: rows.reduce((s, r) => s + (r.total_order || 0), 0),
      total_amount: rows.reduce((s, r) => s + (r.total_amount || 0), 0)
    };
  }

  groupBreakdown(groupId: string): Array<{ name: string; total_order: number; total_amount: number }> {
    return this.channels
      .filter(c => c.platform_group_id === groupId)
      .map(channel => {
        const rows = this.formattedData.filter(r => r.channel === channel.shop_ref);
        return {
          name: channel.platform_name || channel.shop_ref,
          total_order: rows.reduce((s, r) => s + (r.total_order || 0), 0),
          total_amount: rows.reduce((s, r) => s + (r.total_amount || 0), 0)
        };
      })
      .sort((a, b) => {
        const metric = this.displayData;
        return (b[metric] || 0) - (a[metric] || 0);
      });
  }

  channelPercent(channel: { total_order: number; total_amount: number }, groupId: string): number {
    const total = this.groupTotal(groupId);
    const denom = this.displayData === 'total_order' ? total.total_order : total.total_amount;
    if (denom <= 0) return 0;
    const value = this.displayData === 'total_order' ? channel.total_order : channel.total_amount;
    return (value / denom) * 100;
  }

  onChartBarClick(event: any): void {
    const groupName = typeof event === 'string' ? event : event?.name;
    if (!groupName) return;
    const group = this.platformGroup.find(g => g.name === groupName);
    if (!group) return;
    this.expandedGroups.add(group.id);
    setTimeout(() => {
      const el = document.querySelector(`[data-group-row="${group.id}"]`);
      el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 50);
  }
}
